import { render, staticRenderFns } from "./TicketChat.vue?vue&type=template&id=691079ac&scoped=true"
import script from "./TicketChat.vue?vue&type=script&lang=js"
export * from "./TicketChat.vue?vue&type=script&lang=js"
import style0 from "./TicketChat.vue?vue&type=style&index=0&id=691079ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691079ac",
  null
  
)

export default component.exports